module.exports = __webpack_public_path__ + "static/media/dokfy-logo.cc3c11a3.png";